export default {
  'PARTNER_CATEGORY' (state) {
    return state.category
  },
  'PARTNER_CATEGORIES' (state) {
    return state.categories
  }
}
